import { render } from "./ResultsDisplay.vue?vue&type=template&id=05b481f8&scoped=true"
import script from "./ResultsDisplay.vue?vue&type=script&lang=js"
export * from "./ResultsDisplay.vue?vue&type=script&lang=js"

import "./ResultsDisplay.vue?vue&type=style&index=0&id=05b481f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b481f8"]])

export default __exports__